import { jsx as o, jsxs as l, Fragment as $ } from "react/jsx-runtime";
import { useRef as b } from "react";
import { useMultiStyleConfig as B, Popover as F, PopoverTrigger as R, PopoverContent as j, PopoverArrow as k, PopoverHeader as z, Box as A, PopoverBody as H, PopoverFooter as M } from "@chakra-ui/react";
import { CloseButton as N } from "../../dataDisplay/CloseButton/CloseButton.mjs";
const E = ({
  children: n,
  popoverTrigger: s,
  bodyStyleProps: c,
  closeOnBlur: p = !0,
  closeOnEsc: m = !0,
  footer: r,
  footerStyleProps: u,
  header: t,
  headerStyleProps: v,
  id: P,
  onClose: a,
  onOpen: d,
  placement: f = "bottom",
  showCloseButton: i = !0,
  trigger: h = "click",
  "data-testid": e,
  ...x
}) => {
  const C = B("Popover"), g = b(null);
  return /* @__PURE__ */ o(
    F,
    {
      id: P,
      closeOnBlur: p,
      closeOnEsc: m,
      onClose: a,
      onOpen: d,
      placement: f,
      trigger: h,
      initialFocusRef: g,
      children: ({ onClose: y }) => /* @__PURE__ */ l($, { children: [
        /* @__PURE__ */ o(R, { children: s }),
        /* @__PURE__ */ l(j, { "data-testid": e, ...x, children: [
          /* @__PURE__ */ o(k, {}),
          i && /* @__PURE__ */ o(N, { sx: C.closeButton, "aria-label": "Close", size: "sm", onClick: y }),
          t ? /* @__PURE__ */ o(
            z,
            {
              "data-testid": e && `${e}-header`,
              ...v,
              children: t
            }
          ) : i && /* @__PURE__ */ o(A, { className: "headerspacer" }),
          /* @__PURE__ */ o(H, { "data-testid": e && `${e}-body`, ...c, children: n }),
          r && /* @__PURE__ */ o(
            M,
            {
              "data-testid": e && `${e}-footer`,
              ...u,
              children: r
            }
          )
        ] })
      ] })
    }
  );
};
export {
  E as Popover
};
